<template>
  <StatisticReportDesigner />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
